// 技术生态-waic
<template>
  <div class="ecological-waic" ref="ecological-waic">
    <div class="info">
      <div class="title">
        “认知智能 改变世界”论坛
      </div>
      <div class="desc">
        —— WAIC世界人工智能大会
      </div>
      <div class="content">
        WAIC“认知智能，改变世界”的分论坛由华院计算主办，致力于与全球学术界、产业界携手共进推动认知智能的技术落地应用，共筑认知智能的美好未来。
      </div>
    </div>
    <van-tabs v-model="active" class="tabs" @change="handleTabChange">
      <van-tab v-for="item in tabArr" :key="item" :title="`${item}年`" />
    </van-tabs>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      class="list"
      @load="onLoad"
      offset="0"
    >
      <van-cell v-for="item in newslist" :key="item.id">
        <template #title>
          <div class="cell-content"  @click="getDetail(item.id)">
            <div class="title">{{item.title}}</div>
            <div class="time">{{item.create_time}}</div>
          </div>
        </template>
      </van-cell>
      <img :src="toTop" alt="" class="toTop" @click="goTop">
    </van-list>
  </div>
</template>
<script>
import toTop from '@/../static/img/ecological/toTop.svg'
import { formatCreateTime, getYearFromDate } from '@/utils/dateFormat'
export default {
  name: 'ecological-waic',
  components: {  },
  data() {
    return {
      toTop,
      active: 0,
      loading: false,
      finished: false,
      total: 0,
      page: {
        pageSize: 100,
        currentPage: 1,
      },
      tabArr: [],
      newslistAll: [],
      newslist: []
    }
  },
  mounted() {
    this.getNewList();
  },
  methods: {
    getNewList(val) {
      let _this = this;
      let postdata = {
        type: "waic",
        page: val || 1,
        pagesize: this.page.pageSize
      };
      this.axios
        .post(this.$rootUrl + "/unidt/query_article_page", postdata)
        .then(function(res) {
          const { data, code, total_count } = res.data;
          if (code === 200) {
            let arr = []
            let list = []
            _this.total = total_count;
            data.forEach(item => {
              formatCreateTime(item)
              const year = getYearFromDate(item.create_time)
              if (arr.includes(year)) {
                let checkData = list.filter(it => it.year == year)[0]
                checkData.children.push(item)
              } else {
                arr.push(year)
                list.push({ year, children: [item] })
              }
            })
            _this.tabArr = arr.sort((a, b) => b - a);
            _this.newslistAll = list.sort((a, b) => b.year - a.year)
            _this.newslist = _this.newslistAll[0].children.slice(0, 10);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    newsDetailHandle(id) {
      let _this = this;
      this.loading = true;
      this.axios
        .get(this.$rootUrl + "/unidt/get_article" + "?id=" + id)
        .then(function(res) {
          _this.newsDetail = { ...res.data.data };
          _this.detailShow = true;
          _this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        if (this.page.currentPage > 1) this.newslist = this.newslist.concat(...this.newslistAll[this.active].children.slice((this.page.currentPage - 1) * 10, (this.page.currentPage - 1) * 10 + 10))
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.newslist.length >= this.newslistAll[this.active].children.length ) {
          this.finished = true;
        } else {
          this.page.currentPage = this.page.currentPage + 1
        }
      }, 1000);
    },
    handleTabChange(e) {
      this.page.currentPage = 1;
      this.newslist = this.newslistAll[e].children.slice(0, 10)
    },
    getDetail(id) {
      this.$router.push({
        path: '/ecologicalWaicDetail',
        query: {
          id
        }
      })
    },
    goTop() {
      document.documentElement.scrollTop = 632 * (document.documentElement.clientWidth / 750)
    }
  }
}
</script>
<style lang="less" scoped>
.ecological-waic {
  width: 100%;
  padding: 96px 0px 0px;
  background: #ffffff;
  .info {
    height: 536px;
    background: url('../../../../static/img/ecological/ecological_waic_bg.png') no-repeat 0 0 / 100%;
    overflow: hidden;
    text-align: center;
    padding: 48px 68px;
    .title {
      font-size: 44px;
      color: #08204D;
      line-height: 60px;
    }
    .desc {
      margin-top: 20px;
      font-size: 32px;
      color: #08204D;
      line-height: 44px;
    }
    .content {
      margin-top: 44px;
      font-size: 24px;
      font-weight: 400;
      color: #08204D;
      line-height: 40px;
      text-align: left;
    }
  }
  .tabs {
    height: 94px;
    /deep/.van-tabs__wrap {
      height: 94px;
      .van-tab__text {
        height: 100%;
        font-size: 26px;
        line-height: 94px;
        color: #08204D;
      }
    }
    /deep/.van-tab--active >span {
      color: #2632FA !important;
    }
    /deep/.van-tabs__line {
      background-color: #2632FA;
    }
  }
  .list {
    position: relative;
    .cell-content {
      display: flex;
      flex-direction: column;
      padding: 16px 64px;
      .title {
        font-size: 28px;
        color: #08204D;
        line-height: 40px;
      }
      .time {
        margin-top: 16px;
        font-size: 24px;
        font-weight: 400;
        color: #97A2B5;
        line-height: 36px;
      }
    }
    .toTop {
      position: fixed;
      right: 15px;
      bottom: 20%;
      width: 83px;
      height: 83px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/ecological/waic/index.vue